import { combineReducers } from 'redux'

import { authenticationReducer } from '@SiteModules/Authentication/reducer'
import { popupReducer} from '@SiteModules/Popup/reducer'
import { projectVersionSettingsReducer } from '@SiteModules/ProjectVersionSettings/reducer'
import { projectVersionSettingsTtsReducer } from '@SiteModules/ProjectVersionSettingsTts/reducer'
import { externalTokenReducer } from '@SiteModules/ExternalToken/reducer'
import { projectsReducer } from '@SiteModules/Project/reducer'
import { labelsReducer } from '@SiteModules/Label/reducer'
import { subtitlesReducer } from '@SiteModules/Subtitle/reducer'
import { userReducer } from '@SiteModules/User/reducer'
import { vocabulariesReducer } from '@SiteModules/Vocabulary/reducer'
import { elementsReducer } from '@SiteModules/Element/reducer'
import { externalChannelsReducer } from '@SiteModules/ExternalChannel/reducer'
import { themesReducer } from '@SiteModules/Theme/reducer'
import { exportationsReducer } from '@SiteModules/Exportation/reducer'
import { processingReducer } from '@SitePages/Processing/reducer'
import { guidelinesReducer } from '@SiteModules/Guideline/reducer'
import { termbasesReducer } from '@SiteModules/Termbase/reducer'
import { accountsReducer } from '@SiteModules/Account/reducer'
import { workspacesReducer } from '@SiteModules/Workspace/reducer'
import { accountUsersReducer } from '@SiteModules/AccountUser/reducer'
import { speakerVoicesReducer } from '@SiteModules/SpeakerVoice/reducer'
import { statisticsReducer } from '@SiteModules/Statistics/reducer'

import { IAuthenticationState } from '@SiteModules/Authentication/types'
import { IPopupState } from '@SiteModules/Popup/types'
import { IProjectVersionSettingsState } from '@SiteModules/ProjectVersionSettings/types'
import { IProjectVersionSettingsTtsState } from '@SiteModules/ProjectVersionSettingsTts/types'
import { IExternalTokenState } from '@SiteModules/ExternalToken/types'
import { ILabelState } from '@SiteModules/Label/types'
import { IProjectState } from '@SiteModules/Project/types'
import { ISubtitleState } from '@SiteModules/Subtitle/types'
import { IUserState } from '@SiteModules/User/types'
import { IVocabularyState } from '@SiteModules/Vocabulary/types'
import { IElementState } from '@SiteModules/Element/types'
import { IExternalChannelState } from '@SiteModules/ExternalChannel/types'
import { IThemeState } from '@SiteModules/Theme/types'
import { IExportationState } from '@SiteModules/Exportation/types'
import { IProcessingState } from '@SitePages/Processing/types'
import { IGuidelineState } from '@SiteModules/Guideline/types'
import { ITermbaseState } from '@SiteModules/Termbase/types'
import { IAccountState } from '@SiteModules/Account/types'
import { IWorkspaceState } from '@SiteModules/Workspace/types'
import { IAccountUserState } from '@SiteModules/AccountUser/types'
import { ISpeakerVoiceState } from '@SiteModules/SpeakerVoice/types'
import { IStatisticsState } from '@SiteModules/Statistics/types'

export interface IApplicationState {
  readonly authentication: IAuthenticationState
  readonly user: IUserState
  readonly accounts: IAccountState
  readonly workspaces: IWorkspaceState
  readonly labels: ILabelState
  readonly elements: IElementState
  readonly subtitles: ISubtitleState
  readonly vocabularies: IVocabularyState
  readonly projects: IProjectState
  readonly projectVersionSettings: IProjectVersionSettingsState
  readonly projectVersionSettingsTts: IProjectVersionSettingsTtsState
  readonly externalToken: IExternalTokenState
  readonly popup: IPopupState
  readonly externalChannels: IExternalChannelState
  readonly themes: IThemeState
  readonly exportations: IExportationState
  readonly processing: IProcessingState
  readonly guidelines: IGuidelineState
  readonly termbases: ITermbaseState
  readonly accountUsers: IAccountUserState
  readonly speakerVoices: ISpeakerVoiceState
  readonly statistics: IStatisticsState
}

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  user: userReducer,
  labels: labelsReducer,
  subtitles: subtitlesReducer,
  projects: projectsReducer,
  vocabularies: vocabulariesReducer,
  projectVersionSettings: projectVersionSettingsReducer,
  projectVersionSettingsTts: projectVersionSettingsTtsReducer,
  externalToken: externalTokenReducer,
  popup: popupReducer,
  externalChannels: externalChannelsReducer,
  elements: elementsReducer,
  themes: themesReducer,
  exportations: exportationsReducer,
  processing: processingReducer,
  guidelines: guidelinesReducer,
  termbases: termbasesReducer,
  workspaces: workspacesReducer,
  accounts: accountsReducer,
  accountUsers: accountUsersReducer,
  speakerVoices: speakerVoicesReducer,
  statistics: statisticsReducer,
})

export default rootReducer
